(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  var roots = document.querySelectorAll('[data-ab-id]');
  roots.forEach(function(root) {
    /* Persistent dismiss */
    var version = (root.getAttribute('data-ab-version') || '1').toString();
    var expiry  = parseInt(root.getAttribute('data-ab-expiry') || '0', 10) || 0;
    var key     = 'ab:' + root.getAttribute('data-ab-id') + ':v:' + version;

    try {
      var raw = localStorage.getItem(key);
      if (raw) {
        var rec = JSON.parse(raw);
        if (rec && typeof rec.ts === 'number') {
          if (expiry === 0) {
            root.hidden = true;
          } else {
            var now = Date.now();
            var ms  = expiry * 24 * 60 * 60 * 1000;
            if (now - rec.ts < ms) {
              root.hidden = true;
            } else {
              localStorage.removeItem(key);
            }
          }
        }
      }
    } catch(e) {}

    var btn = root.querySelector('.e-ab__dismiss');
    if (btn) {
      btn.addEventListener('click', function() {
        try { localStorage.setItem(key, JSON.stringify({ ts: Date.now() })); } catch(e) {}
        root.hidden = true;
      });
    }

    /* Seamless marquee enhancer */
    var viewport = root.querySelector('.e-ab__viewport');
    var track    = root.querySelector('.e-ab__track');
    if (!viewport || !track) return;

    function setupMarquee() {
      // reset any previous clones & inline vars
      var groups = track.querySelectorAll('.e-ab__group');
      if (!groups.length) return;

      // Keep only the first group, remove the rest, then add ONE duplicate (so we have 2)
      var first = groups[0];
      Array.from(groups).slice(1).forEach(function(g){ g.remove(); });
      track.appendChild(first.cloneNode(true));

      // Measure and ensure the track is at least viewport width + first group width
      var firstWidth = first.getBoundingClientRect().width;
      if (!firstWidth) return;

      while (track.scrollWidth < viewport.clientWidth + firstWidth) {
        track.appendChild(first.cloneNode(true));
      }

      // Set animation distance to exactly one original group width
      track.style.setProperty('--e-ab-distance', firstWidth + 'px');
    }

    // Initial setup
    setupMarquee();

    // Re-run after fonts load (for webfont metrics)
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(setupMarquee).catch(function(){});
    }

    // Re-run on resize
    try {
      var ro = new ResizeObserver(function(){ setupMarquee(); });
      ro.observe(viewport);
    } catch(e) {
      window.addEventListener('resize', setupMarquee);
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;
      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }
  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() { super(); }
    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }
    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }
    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }
    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }
    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }
    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }
  customElements.define('sticky-header', StickyHeader);

  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
(() => {
  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      // If there’s no URL, nothing to do.
      if (!this.dataset.url) return;

      // Load immediately in the Theme Editor or if IntersectionObserver isn't available.
      const inEditor = !!(window.Shopify && Shopify.designMode);
      if (inEditor || !('IntersectionObserver' in window)) {
        this._load(); 
        return;
      }

      // Lazy load when visible.
      this._io = new IntersectionObserver((entries, obs) => {
        if (!entries[0].isIntersecting) return;
        obs.unobserve(this);
        this._load();
      }, { rootMargin: '0px 0px 200px 0px' });

      this._io.observe(this);
    }

    _load() {
      fetch(this.dataset.url)
        .then(r => r.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recs = html.querySelector('product-recommendations');
          if (recs && recs.innerHTML.trim().length) {
            this.innerHTML = recs.innerHTML;
          }
          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch(console.error);
    }
  }

  // Avoid double-registering the element (which throws and breaks the script).
  if (!customElements.get('product-recommendations')) {
    customElements.define('product-recommendations', ProductRecommendations);
  }
})();

  } catch(e) { console.error(e); }
})();
})();
